import React, { useState } from 'react'
import SVGIcon from '../helpers/icons'
import axios from 'axios'
import Spinner from './Spinner'

function TipContentVideo (props) {
  const video_id = props.settings.video // Example 9011932
  const [videoIframe, setVideoIframe] = useState(null)

  const fetchVideoSettings = function () {
    axios.get('https://vimeo.com/api/oembed.json?url=https://vimeo.com/' + video_id).then(function (response) {
      if (response.status !== 200) return
      if (typeof response.data !== 'object' || typeof response.data.html !== 'string') return
      setVideoIframe(response.data.html)
    })
  }

  if (videoIframe === null) {
    fetchVideoSettings()
  }

  return (
    <div className={'tip-modal-content video'}>
      <div className={'tip-modal__video'}>
        {videoIframe === null ? <Spinner/> : <figure dangerouslySetInnerHTML={{ __html: videoIframe }}></figure>}
      </div>
      <button onClick={props.closemodal} aria-label={props.closeLabel} className={'close-button'}>
        <SVGIcon type={'close'} fill={'#FFF'} className={'close-button__icon'}/>
      </button>
    </div>
  )
}

TipContentVideo.defaultProps = {
  closeLabel: 'Close modal',
}

export default TipContentVideo